<template>
  <div class="solutegropContent">
    <div class="headercont">
      <img
        src="../../assets/img/solute/banner1.png"
        alt=""
        style="width:100%;height: 100%;vertical-align:middle;object-fit:contain;;"
      />
      <div class="betweencenter">
        <div class="real">
          <div class="tis bigcolor">{{$t('contySolution.title')}}</div>
          <div class="tixt middlecolorc">
            {{$t('contySolution.text')}}
          </div>
        </div>
      </div>
    </div>
    <div style="margin:100px 0;">
      <h1>{{$t('contySolution.header')}}</h1>
      <div class="botcolor">Solution</div>
      <div class="colors matter">{{ $t('contySolution.master') }}</div>
    </div>
    <div class="solution">
      <!-- 业务需求 -->
      <div class="buisnessrequire">
        <div class="buisnesstext">
          <h1>{{ $t('contySolution.businessRequire') }}</h1>
          <ul style="margin-top:60px;">
            <li
              v-for="(item, index) in $t('contySolution.businessList')"
              :key="index"
              class="colors hes"
              :title="item.name"
            >
               • {{ item.name |ellipsis}}
            </li>
          </ul>
          <h1 style="margin-top:60px;">{{ $t('contySolution.solutions') }}</h1>
          <ul style="margin-top:60px;">
            <li
              v-for="(item, index) in $t('contySolution.solutionList')"
              class="colors hes"
              :key="index"
              :title="item.name"
            >
               • {{ item.name|ellipsis }}
            </li>
          </ul>
        </div>
        <div class="buisness">
          <img src="../../assets/img/solute/siyou.png" alt="" />
        </div>
      </div>
    </div>
    <div class="advantage">
      <!-- 优势 -->
      <div style="margin:77px 0 20px 0;">
        <h1>{{ $t('contySolution.advantage') }}</h1>
        <div class="botcolor">Advantage</div>
      </div>
      <div class="contentcase">
        <div class="navs">
          <div v-for="(item, it) in $t('contySolution.textlist')" :key="it" class="list">
            <img
              :src="item.img"
              alt=""
              class="imgtop"
              @click="tapcase(item.type)"
            />
            <div class="bottom clearfix" @click="tapcase(item.type)">
              <div @click="tapcase(item.type)">
                <p class="middlecolors fontw">
                  {{ item.name }}
                </p>
                <p class="colors" style="margin-top:10px;" :title="item.title">
                   {{ item.title |ellipsis}}
                </p>
              </div>
              <div class="btn"></div>
            </div>
          </div>
        </div>
      </div>
    </div>
    <div class="solution">
      <!-- 服务 -->
      <div class="oneserve">
        <div style="padding-top:60px;margin-bottom:50px;">
          <h1>{{ $t('contySolution.serve') }}</h1>
        </div>
        <div class="services">
          <div class="headerTitle">
            <div
              class="fontws"
              @click="tapphone(it)"
              v-for="(item, it) in $t('contySolution.serviceList')"
              :key="it"
            >
              <div>
                <img :src="item.img" alt="" />
              </div>
              <span
                class="fontw fonttop"
                :class="selecteds == it ? 'active' : 'one'"
                >{{ item.title }}</span
              >
              <div class="mixture">
                <div class="formsign colors">{{ item.name }}</div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>
<script>
export default {
  data() {
    return {
      textlist: [
        {
          name: "降低成本",
          img: require("../../assets/img/solute/05.png"),
          title:
            "采用天弛网络技术，利用天弛SDN高可用骨干网络和SD-WAN产品，主要应用使用专线，非主要应用使用备线网络，节约专线流量，有效降低成本",
          type: 1
        },
        {
          name: "优化路由和提高可用性",
          img: require("../../assets/img/solute/06.png"),
          title:
            "通过双网双用，让设备/线路/网络全面冗余，增强网络系统的安全性和可靠性",
          type: 2
        },
        {
          name: "资源高效利用",
          img: require("../../assets/img/solute/07.png"),
          title:
            "基于天弛骨干网络技术，让不同的应用走不同的网络线路，充分利用企业的现有网络资源，提升网络带宽利用率",
          type: 3
        },
        {
          name: "一站式服务",
          img: require("../../assets/img/solute/08.png"),
          title:
            "天弛提供线路和设备申请/安装/调试/运维等一站式服务，7*24小时的专家运维团队售后支持服务，快速响应客户的需求，解决问题",
          type: 4
        }
      ],
      title: "简介",
      matter:
        "天弛基于SD-WAN骨干网资源，提供企业总部与分支组网服务，实现不同地区、 不同规模的分支机构间的高速、高质量通信，打造安全、协同、互联的办公网络，大幅提升企业与分支机构的业务互通效率。",
      solutions: "解决方案",
      solutionList: [
        {
          name:
            "借助天弛广泛覆盖的全球POP节点，实现企业就近接入，并完成大陆及海外各自区域内分支机构的互联"
        },
        {
          name:
            "基于庞大的公有云、数据中心等资源，提供混合网络架构、跨数据中心专线互联与混合云专线互联服务，实现灵活一体的基础设施环境"
        }
      ],
      businessRequire: "业务需求",
      businessList: [
        {
          name: "保证企业网的安全性与保密性，避免内部数据外泄"
        },
        {
          name:
            "实现总部与各分支之间的资源共享与数据实时同步，更好的保证协同工作"
        }
      ],
      advantage: "优势",
      serve: "企业私有网服务",
      serviceList: [
        {
          img: require("../../assets/img/solute/alile.png"),
          title: "灵活组网",
          name:
            "可根据企业不同分支机构的地域分布、规模大小以及实际网络需求等，提供灵活的组网方式；可通过不同的接入方式接入到天弛的POP点，可接受运营商专线，裸纤，SD-WAN，机房内跳线等不同的接入方式"
        },
        {
          img: require("../../assets/img/solute/global.png"),
          title: "服务范围覆盖全球",
          name:
            "网络覆盖全球的100多家数据中心节点、是30+IDC服务商是合作伙伴关系，构建的庞大资源池，整合骨干网络资源，帮助企业实现大陆及海外各自区域内的网络能力的延伸，并为企业提供优质的网络体验"
        },
        {
          img: require("../../assets/img/solute/usebale.png"),
          title: "线路稳定、可用率高",
          name:
            "绕过公共互联网的不可靠性，提供稳定的网络访问速度，并通过路由优化与协议优化方式保证服务的高可用性，可用率可到99.95%"
        },
        {
          img: require("../../assets/img/solute/network.png"),
          title: "统一的网络管理",
          name:
            "企业总部与分支机构的网络形成一个完整的网络，便于全程监控和实现二层网络故障自切换，实现了企业网络的统一管控"
        }
      ],
      tapflag: true,
      selecteds: ""
    };
  },
  methods: {
    tapphone(it) {
      switch (it) {
        case 0:
          this.selecteds = it;
          break;
        case 1:
          this.selecteds = it;
          break;
        case 2:
          this.selecteds = it;
          break;
        default:
          this.selecteds = it;
          break;
      }
    }
  }
};
</script>
<style lang="scss" scoped>
.solutegropContent {
  width: 100%;
  margin: 0 auto;
  .matter {
    margin: auto;
    width: 629px;
    line-height: 27px;
    text-align: center;
    margin-top: 20px;
  }
  .headercont {
    position: relative;
    .betweencenter {
      width: 1200px;
      margin: 0 auto;
      .real {
        position: absolute;
        top: 150px;
        z-index: 1000;
        text-align: left;
        .tis {
          // width: 420px;
          letter-spacing: 0px;
          line-height: 16px;
          font-size: 48px;
        }
        .tixt {
          width: 420px;
          margin-top: 36px;
          line-height: 23px;
          letter-spacing: 1px;
        }
      }
    }
  }

  .solution {
    width: 100%;
    background-color: #f4f4f4;
    // 业务需求
    .buisnessrequire {
      width: 1200px;
      // height: 859px;
      margin: 0 auto;
      display: flex;
      justify-content: space-between;
      padding: 100px 0;
      box-sizing: border-box;
      position: relative;
      .buisness {
        img {
          width: 100%;
          height: 100%;
          vertical-align: middle;
        }
      }
      .buisnesstext {
        text-align: left;
        box-sizing: border-box;
        margin-right: 70px;
        .hes {
          width: 467px;
          line-height: 30px;
          box-sizing: border-box;
        }
      }
    }
    // 服务
    .oneserve {
      width: 1200px;
      margin: 0 auto;
      box-sizing: border-box;
      margin-top: 80px;
      padding-bottom: 80px;
      .services {
        width: 100%;
        .headerTitle {
          width: 100%;
          display: flex;
          justify-content: center;
          cursor: pointer;
          .fontws {
            width: 25%;
            margin: 0 auto;
            display: flex;
            flex-direction: column;
            img {
              height: 100px;
              vertical-align: middle;
            }
            .fonttop {
              height: 60px;
              line-height: 60px;
            }
            .one {
              font-size: 16px;
            }
            .mixture {
              border-top: 1px solid #ccc;
              padding: 20px 20px;
              box-sizing: border-box;
              .formsign {
                width: 100%;
                text-align: left;
              }
            }
          }
          .active {
            width: 100%;
            height: 100%;
            background: url("../../assets/img/main/cursor.png") no-repeat bottom
              center;
            background-size: 186px 11px;
            font-size: 16px;
          }
        }
      }
    }
  }
  .advantage {
    width: 1200px;
    margin: 0 auto;
    // 优势
    .contentcase {
      .navs {
        width: 100%;
        height: 100%;
        display: flex;
        justify-content: space-between;
        flex-wrap: wrap;
        .list {
          width: 590px;
          height: 470px;
          margin-bottom: 30px;
          .el-card {
            width: 100% !important;
            height: 100% !important;
          }
          .el-card__body {
            box-sizing: border-box;
            width: 100% !important;
            height: 100% !important;
          }
          .imgtop {
            max-width: 590px;
            max-height: 300px;
            vertical-align: middle;
          }
          .bottom {
            margin-top: 20px;
            box-sizing: border-box;
            padding: 22px 37px 34px 28px;
            text-align: left;
            display: flex;
            justify-content: space-between;
            height: 163px;
            border: 1px solid #248f47;
          }
          .bottom:hover {
            background: #248f47;
            .middlecolors {
              font-size: 16px !important;
              color: #fff !important;
            }
            .colors {
              font-size: 16px !important;
              color: #fff !important;
            }
          }
          .clearfix:before,
          .clearfix:after {
            display: table;
            content: "";
          }

          .clearfix:after {
            clear: both;
          }
        }
      }
    }
  }
}
</style>
